// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"yP-z","inlineTitle":"zP-z","sponsoredAdsWrapper":"AP-z","marketplaceRecosWrapper":"BP-z"};